import Submenu from '../menu/src/submenu';

Submenu.install = function(Vue) {
  Vue.component(Submenu.name, Submenu);
};

export default Submenu;



// WEBPACK FOOTER //
// ./src/components/submenu/index.js